module.exports = __webpack_public_path__ + "img/gov-logo.2a712e11.svg";